export default {
    mounted(el) {
      el.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          const formElements = Array.from(
            el.form.querySelectorAll("input, select, textarea, button")
          ).filter((e) => !e.disabled);
          const currentIndex = formElements.indexOf(el);
          const nextElement = formElements[currentIndex + 1];
          if (nextElement) {
            nextElement.focus();
          }
        }
      });
    },
  };
  